<template>
  <div>
    <!-- <title-bar :title="$lang.Depósito"></title-bar> -->

    <div
      class="d-flex-s"
      style="
        height: 55px;
        background: #232433;
        padding: 0 10px;
        position: sticky;
        top: 0;
        z-index: 999;
      "
    >
      <div class="d-flex">
        <van-icon @click="goLeft()" name="arrow-left" size="20" />
        <span class="f-t-16 m-l-10">{{ $lang.Depósito }}</span>
        <div
          class="d-flex m-l-20 f-t-15"
          style="background: #181924; padding-right: 10px; border-radius: 20px"
        >
          <img src="../../assets/img/otgame/amount.png" width="15" />
          <span
            class="m-l-5"
            style="color: rgb(255, 214, 50); min-width: 50px; padding: 2px 0"
            >{{ blance }}</span
          >
        </div>
      </div>
      <p @click="goToRecord" class="f-t-15" style="text-decoration: underline">
        {{ $lang.common_txt256 }}
      </p>
    </div>

    <div class="RechargeCont-cont">
      <div class="d-flex-s" style="margin-bottom: 15px">
        <p class="f-t-15 f-w">{{ $lang.common_txt308 }}</p>
        <p style="color: #1bcd0d; text-decoration: underline; cursor: pointer" @click="$jumpTo('/vipLevels')">
          {{ $lang.common_txt309 }}
        </p>
      </div>
      <!-- <div class="d-flex recharge-item m-t-10" style="flex-flow: wrap row">
        <div
          v-for="(item, index2) in paymentList"
          :key="index2"
          @click="tabIndex(index2)"
          class="type-item d-flex"
          style="justify-content: center"
          :class="{ 'active-bor': selectIndex === index2 }"
        >
          <img
            :src="
              selectIndex === index2
                ? item.paymentIconUrl.replace('.png', '_sel.png')
                : item.paymentIconUrl
            "
            width="20"
            class="m-r-5"
          />
          {{ item.paymentName }}
        </div>
      </div> -->
      <!-- 修复：移除可选链操作符，改用Vue 2支持的写法 -->
      <div
        v-if="
          paymentList.length > 0 &&
          paymentList[selectIndex].paymentId === 'USDT'
        "
      >
        <!-- <p class="f-t-14 m-t-10">{{ $lang.common_txt246 }}</p> -->
        <div class="d-flex m-t-10">
          <div
            v-for="(item, index) in ['Tron(TRC20)', 'Ethereum(ERC20)']"
            :key="index"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 10px;
              border-radius: 10px;
              margin-right: 10px;
              margin-bottom: 10px;
              background: #454654;
            "
            :class="{ 'active-type2': selectWl === index }"
            @click="getSelectWl(index)"
          >
            {{ item }}
          </div>
        </div>
        <!-- <div>
          {{ $lang.common_txt257 }}
        </div> -->
      </div>

      <!-- 首充赠送活动提示 -->
      <div v-if="firstRecharge && activities.length > 0" class="first-recharge-banner">
        <img src="../../assets/img/otgame/recharge_4.png" width="20" />
        <span class="first-recharge-banner__text">{{ $lang.rc_first_deposit_bonus || 'First Deposit Bonus' }}</span>
      </div>

      <div class="amount-box-list d-flex-s">
        <div
          class="amount-box-list-item"
          v-for="(item, index) in dataList"
          :key="index"
          :class="{ active: index === selectAmountIndex || item.isActive }"
          @click="selectAmount(index, item)"
        >
          <div class="t-c">
            <span
              v-if="firstRecharge && item.bonus"
              class="amount-bonus-badge"
            >+{{ $formatNumberWithCommas(item.bonus) }}</span>
            <span style="width: 100%" class="t-c f-w f-t-14">
              {{ $formatNumberWithCommas(item.amount) }}</span
            >
          </div>
        </div>
      </div>

      <p style="color: #7c99ab; margin-top: 5px">
        {{ $lang.common_txt311 }} {{ minAmount }}
      </p>
      <van-field
        v-model="amount"
        :placeholder="$lang.common_txt143"
        class="custom-field m-t-5"
        type="number"
        :style="{ borderColor: focus ? '#55657E' : '#55657E' }"
        @input="handleInput"
        @focus="focus = true"
        @blur="focus = false"
      >
        <template #left-icon>
          <!-- 修复：移除可选链操作符 -->

          <div class="d-flex">
            <span class="f-t-15 m-r-10" style="color: #c9dae9"
              >{{
                paymentList.length > 0 &&
                paymentList[selectIndex].paymentId !== 'USDT'
                  ? getCurrency
                  : 'U'
              }}
            </span>
            <span style="margin-top: -3px">|</span>
          </div>
        </template>
      </van-field>
      <p class="m-t-5 d-flex" style="cursor: pointer" @click="$jumpTo('/vipLevels')">
        <img
          :src="
            require(`@/assets/img/vip/V${
              InitDate.vipLevel ? InitDate.vipLevel : 0
            }.png`)
          "
          height="18"
        />
        <span class="m-l-5">{{ $lang.common_txt312 }}</span>
      </p>
      <div
        style="
          background: #222534;
          border: 1px solid #555666;
          border-radius: 8px;
          padding: 10px;
          margin-top: 5px;
        "
      >
        <div class="f-t-15">
          <span style="color: #21dd17">
            {{ $lang.common_txt313 }}
          </span>
          <span style="color: #ffcd34">{{ totalMount }}</span>
        </div>
      </div>

      <!-- 修复：移除可选链操作符 -->
      <p
        v-if="
          paymentList.length > 0 &&
          paymentList[selectIndex].paymentId === 'USDT'
        "
        class="f-t-13 m-t-5 m-l-10"
      >
        ≈ {{ $formatNumberWithCommas(TotalHl) }}{{ getCurrency }} ({{
          $lang.common_txt247
        }})
      </p>

      <div class="t-c" style="margin-top: 20px">
        <van-button
          @click="submit"
          size="large"
          class="custom-button f-t-18"
          style="
            width: 100%;
            height: 48px;
            background: linear-gradient(270deg, #7b1af2, #a81ce6);
          "
          :class="{ 'active-b': isLoading }"
          :disabled="isLoading"
        >
          {{ $lang.common_txt314 }} {{ getCurrency }} {{ amount }}
        </van-button>
      </div>
      <div v-if="!['usdt', 'otpay'].includes(paymentKey)">
        <div
          class="d-flex f-t-15"
          style="margin: 15px 0 20px; justify-content: center"
        >
          <img :src="GET_ICONURL" width="25" />
          <span
            style="font-weight: bold; margin-left: 3px; margin-right: 10px"
            >{{ GET_AREACODE }}</span
          >

          <span>{{ account }}</span>
        </div>
        <div
          style="
            color: #aeb6cf;
            font-size: 15px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 15px;
            line-height: 20px;
          "
        >
          {{ $lang.common_txt362 }}
        </div>
      </div>
      <div class="deposit_share t-c">
        <p class="f-t-15 f-w" style="color: #1cdd32">
          {{ $lang.common_txt315 }}
        </p>
        <p
          class="m-t-5"
          style="line-height: 20px"
          v-html="$lang.common_txt316"
        ></p>
        <img
          src="../../assets/img/otgame/zjm_40.png"
          width="35"
          style="cursor: pointer"
          @click="openTgCustomerService"
        />
      </div>

      <div class="d-flex m-t-15" style="justify-content: center">
        <img src="../../assets/img/otgame/cdk_4.png" height="12" width="28%" />
        <p style="margin: 0 20px">{{ $lang.common_txt317 }}</p>
        <img src="../../assets/img/otgame/cdk_3.png" height="12" width="28%" />
      </div>
      <div
        v-html="$lang.common_txt30"
        class="l-h-20"
        style="width: 96%; margin: 0 auto; color: #6e728c"
      ></div>
    </div>
    <div
      style="
        position: fixed;
        bottom: 60px;
        left: 0;
        right: 0;
        margin: 0 auto;
        max-width: 450px;
        background: #1a212e;
      "
    >
      <div style="padding: 10px">
        <!-- 修改：从固定的['Fiat', 'Crypto']改为渲染paymentList -->
        <div class="d-flex">
          <div
            v-for="(item, index) in paymentList"
            :key="index"
            class="t-c f-t-13 f-w m-r-10"
            style="
              height: 58px;
              min-width: 58px;
              background: #3d4654;
              border-radius: 10px;
              padding-top: 10px;
            "
            :class="{ 'active-type': selectIndex === index }"
            @click="tabIndex(index)"
          >
            <!-- <img
              :src="
                selectIndex === index
                  ? item.paymentIconUrl.replace('.png', '_sel.png')
                  : item.paymentIconUrl
              "
              width="20"
              class="m-r-5"
            /> -->
            <img :src="item.paymentIconUrl" width="40" height="22" />
            <p>{{ item.paymentName }}</p>
          </div>
        </div>

        <div
          class="d-flex m-t-10"
          style="
            justify-content: center;
            border: 1px solid #fa9614;
            border-radius: 10px;
            padding: 6px 0;
            background: #263144;
          "
          :class="{
            'active-type3':
              paymentList.length > 0 &&
              paymentList[selectIndex].paymentId !== 'USDT'
          }"
        >
          <img src="../../assets/img/otgame/Withdraw_1.png" width="15" />
          <span class="m-l-10" style="color: #1ccf0e">{{
            $lang.common_txt257
          }}</span>
        </div>
      </div>
    </div>

    <van-popup
      v-model="orangShow"
      closeable
      close-icon-position="top-right"
      style="
        background: #232433;
        width: 90%;
        border-radius: 10px;
        padding: 20px;
      "
    >
      <div>
        <div class="m-t-20 f-t-15 t-c f-w">
          {{ $lang.common_txt363 }}
        </div>
        <div style="line-height: 20px; margin-top: 10px">
          <div style="display: inline-block">
            <span v-html="$lang.common_txt365"></span>
            <span class="info-color">{{ awardRules }}{{ amount }}#</span>
            <span v-html="$lang.common_txt368"></span>
          </div>
          <p class="m-t-10 info-color t-c">
            <span>{{ $lang.common_txt366 }}</span>
            {{ amount }} <span>{{ $lang.common_txt367 }}</span>
          </p>
        </div>

        <van-field
          v-model="uLine"
          class="custom-field m-t-10"
          type="number"
          :placeholder="$lang.common_txt364"
          :maxlength="6"
        >
        </van-field>
        <van-button
          @click="submit"
          size="large"
          class="custom-button f-t-18 m-t-20"
          style="
            width: 100%;
            height: 48px;
            background: linear-gradient(270deg, #7b1af2, #a81ce6);
          "
        >
          {{ $lang.Confirmar }}
        </van-button>
      </div>
    </van-popup>
    <van-popup
      v-model="payInfoShow"
      closeable
      close-icon-position="top-right"
      style="
        background: #232433;
        width: 90%;
        border-radius: 10px;
        padding: 20px;
      "
    >
      <div>
        <div
          class="m-t-10 f-t-18 t-c f-w d-flex"
          style="justify-content: center"
        >
          <img :src="paymentIconUrl" width="73" height="40" />
          <span>{{ paymentName }}</span>
        </div>
        <div style="line-height: 20px; margin-top: 10px">
          <p class="info-color">
            {{ $lang.common_txt370 }} {{ paymentName }}
            {{ $lang.common_txt374 }}
          </p>
          <p v-html="$lang.common_txt371"></p>
          <p v-html="$lang.common_txt372"></p>
          <p class="m-t-20" style="color: #ababac">{{ $lang.common_txt373 }}</p>
        </div>
        <van-button
          @click="payInfoShow = false"
          size="large"
          class="custom-button f-t-18 m-t-20"
          style="
            width: 100%;
            height: 48px;
            background: linear-gradient(270deg, #7b1af2, #a81ce6);
          "
        >
          {{ $lang.Confirmar }}
        </van-button>
      </div>
    </van-popup>
    <!-- 支付弹窗 -->
    <van-popup
      v-model="payShow"
      closeable
      close-icon-position="top-right"
      style="width: 90%; border-radius: 10px; height: 80%"
    >
      <div>
        <iframe
          :src="payUrl"
          scrolling="no"
          style="width: 100%; height: 80vh"
          frameborder="0"
        ></iframe>
      </div>
    </van-popup>
    <!-- 全屏遮罩层 -->
    <van-overlay :show="showOverlay" class="full-screen-overlay">
      <div class="loading-container">
        <van-loading size="30" vertical color="#ffffff">{{
          $lang.common_txt67
        }}</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  Init,
  Pay,
  GetIsFbReport,
  VnRechargeInitS,
  RefreshExchangeRate
} from '@/api/common'
export default {
  name: 'RechargeCont',
  data() {
    return {
      paymentName: '',
      payUrl: '',
      payShow: false,
      uLine: '',
      showOverlay: false, // 控制遮罩层的显示与隐藏
      showBg: false,
      isLoading: false,
      agree: false,
      selectIndex: 0,
      selectAmountIndex: null,
      amount: '',
      focus: false,
      dataList: [],
      paymentType: '',
      paymentKey: '',
      paymentId: '',
      rechargeFees: 0,
      visible: this.value, // 内部状态
      paymentList: [],
      activities: [],
      firstRecharge: false,
      selectWl: 0,
      exchRate: 0, //汇率
      blance: 0,
      minAmount: 0,
      InitDate: {},
      totalMount: 0,
      account: '',
      orangShow: false,
      awardRules: '',
      payInfoShow: false,
      paymentIconUrl: ''
    }
  },
  watch: {
    paymentList: {
      deep: true, // 开启深度监听
      handler() {
        if (this.paymentList.length > 0) {
          this.tabIndex(0)
          // 修复：确保quickSelect存在且有数据
          if (
            this.paymentList[0].quickSelect &&
            this.paymentList[0].quickSelect.length > 1
          ) {
            this.selectAmount(1, this.paymentList[0].quickSelect[1])
            this.amount = this.paymentList[0].quickSelect[1].amount
          } else if (
            this.paymentList[0].quickSelect &&
            this.paymentList[0].quickSelect.length > 0
          ) {
            this.selectAmount(0, this.paymentList[0].quickSelect[0])
            this.amount = this.paymentList[0].quickSelect[0].amount
          }
          // 如果默认选中的是USDT，刷新汇率
          if (this.paymentList[0].paymentId === 'USDT') {
            this.RefreshExchangeRate()
          }
        }
      }
    }
  },
  computed: {
    TotalHl() {
      return this.amount * this.exchRate
    }
  },
  mounted() {
    if (this.token) {
      this.VnRechargeInitS()
      this.Init()
    }
  },
  methods: {
    goToRecord() {
      this.$jumpTo('/recordOrder')
    },
    openTgCustomerService() {
      window.open('https://t.me/OTgamel')
    },
    async Init() {
      const data = await Init()
      if (data.status === 'ok') {
        this.InitDate = data.content
      }
    },
    goLeft() {
      this.$router.go(-1)
    },
    async RefreshExchangeRate() {
      const data = await RefreshExchangeRate({
        exccType: 'USDT',
        rwType: 'r'
      })
      if (data.status === 'ok') {
        this.exchRate = data.content.exchRate
      }
    },
    getSelectWl(i) {
      this.selectWl = i
    },
    goToRechage() {
      this.$jumpTo('/recordOrder')
    },
    goBack() {
      this.visible = false
    },
    async VnRechargeInitS() {
      const data = await VnRechargeInitS()
      if (data.status === 'ok') {
        // 修改：不再过滤paymentList，返回所有支付方式
        this.paymentList = data.content.paymentList
        // 修复：确保paymentList有数据再赋值
        if (this.paymentList.length > 0) {
          this.dataList = this.paymentList[0].quickSelect
        }
        this.activities = data.content.activities || []
        this.firstRecharge = data.content.firstRecharge === true
        this.blance = data.content._balUsable
        this.account = data.content._account
      }
    },
    async GetIsFbReport(v) {
      const data = await GetIsFbReport({
        inviteCode: localStorage.getItem('id')
      })
      if (data.status === 'ok') {
        if (data.content.isReport) {
          if (data.content.target === 'ks') {
            window.kwaiq.load(data.content.fbPixId)
            window.kwaiq.instance(data.content.fbPixId).track('addToCart', {
              value: parseInt(v * 0.1),
              currency: 'NGN'
            })

            console.log('add_to_cart')
          } else {
            this.$pixel.setFbId(data.content.fbPixId)
            this.$pixel.callTrackHasPara('track', 'AddToCart', v * 0.1, 'NGN') // 上报
            const jsonData = `"""{"data":[{"event_name": "Lead","content_name": "Recharge Form","value": ${parseInt(
              v * 0.1
            )},"currency": "NGN"}]}"""`
            this.$pixel.sendEventToAndroid(jsonData)
          }
        }
      }
    },
    async submit() {
      if (
        this.paymentList.length > 0 &&
        this.paymentKey === 'orange' &&
        !this.orangShow &&
        this.GET_PLATFORM !== 'cgbet'
      ) {
        this.orangShow = true
        return
      }
      if (this.orangShow) {
        if (this.uLine.length < 6) {
          this.$toast({
            message: this.$lang.common_txt375,
            icon: 'cross'
          })
          return
        }
      }
      this.isLoading = true
      this.showOverlay = true
      // 修复：添加长度判断，避免数组越界
      if (
        this.paymentList.length > 0 &&
        this.paymentList[this.selectIndex].paymentId === 'USDT'
      ) {
        if (this.selectWl === 0) {
          this.uLine = 'TRON'
        } else if (this.selectWl === 1) {
          this.uLine = 'ETH'
        }
      }
      const data = await Pay({
        paymentAmount: this.amount,
        paymentId: this.paymentId,
        paymentKey: this.paymentKey,
        paymentType: this.paymentType,
        rechargeFees: this.rechargeFees,
        uLine: this.uLine,
        phone: this.account,
        promoType: this.firstRecharge ? (this.activities.length > 0 ? this.activities[0].code : 'first_recharge_new_1') : null
      })
      if (data.status === 'ok') {
        this.orangShow = false
        this.GetIsFbReport(this.amount)
        // 修复：添加长度判断
        if (
          this.paymentList.length > 0 &&
          !['usdt', 'wave'].includes(this.paymentKey) &&
          data.content.url
        ) {
          this.payShow = true
          this.payUrl = data.content.url
          // this.$router.push({
          //   path: '/gameHall',
          //   query: {
          //     from: 'recharge',
          //     url: data.content.url
          //   }
          // })
        } else if (
          this.paymentList.length > 0 &&
          !['usdt', 'wave', 'orange'].includes(this.paymentKey) &&
          !data.content.url
        ) {
          this.payInfoShow = true
        } else if (this.paymentList.length > 0 && this.paymentKey === 'usdt') {
          let obj = {
            orderNo: data.content.orderNo,
            paymentAmount: data.content.paymentAmount,
            paymentId: data.content.paymentId,
            url: data.content.url,
            wlType: this.selectWl === 0 ? 'TRC20' : 'ERC20'
          }
          if (!sessionStorage.getItem('payOrderData')) {
            sessionStorage.setItem('payOrderData', JSON.stringify(obj))
          } else if (
            JSON.parse(sessionStorage.getItem('payOrderData')).orderNo !==
            data.content.orderNo
          ) {
            sessionStorage.setItem('payOrderData', JSON.stringify(obj))
          }
          this.$jumpTo('/payOrder')
        } else if (this.paymentList.length > 0 && this.paymentKey === 'wave') {
          if (data.content.url) {
            window.open(data.content.url, '_blank')
          }
        }
      } else {
        this.$toast({
          message: data.msg,
          icon: 'cross'
        })
      }
      this.isLoading = false
      this.showOverlay = false
    },
    tabIndex(i) {
      this.minAmount = this.paymentList[i].minAmount
      this.selectIndex = i
      this.dataList = this.paymentList[i].quickSelect
      this.dataList.forEach((i) => {
        i.isActive = false
      })
      this.paymentId = this.paymentList[i].paymentId
      this.paymentKey = this.paymentList[i].paymentKey
      this.paymentType = this.paymentList[i].paymentType
      this.rechargeFees = this.paymentList[i].rechargeFees
      this.awardRules = this.paymentList[i].awardRules
      this.paymentIconUrl = this.paymentList[i].paymentIconUrl
      this.paymentName = this.paymentList[i].paymentName
      // 如果切换到USDT支付方式，刷新汇率
      if (this.paymentList[i].paymentId === 'USDT') {
        this.RefreshExchangeRate()
      }
    },
    selectAmount(i, v) {
      this.dataList.forEach((i) => {
        i.isActive = false
      })
      this.selectAmountIndex = i
      this.amount = v.amount
      this.totalMount = this.firstRecharge && v.bonus
        ? parseInt(v.amount) + parseInt(v.bonus)
        : parseInt(v.amount)
    },
    handleInput(i) {
      // 根据输入框的值更新按钮的激活状态
      let matchedBonus = 0
      this.dataList.forEach((item) => {
        item.isActive = parseInt(item.amount) === parseInt(i)
        if (item.isActive && this.firstRecharge && item.bonus) {
          matchedBonus = parseInt(item.bonus)
        }
        this.selectAmountIndex = null
      })
      this.totalMount = this.firstRecharge && matchedBonus
        ? parseInt(i) + matchedBonus
        : parseInt(i) || 0
    }
  }
}
</script>

<style lang="less" scoped>
.deposit_share {
  background: #1d1f2d;
  border-radius: 5px;
  padding: 10px;
}
.RechargeCont-cont {
  padding: 3% 5% 0% 5%;
  overflow-y: auto;
  min-height: 73vh;
  max-height: 77vh;
  border-radius: 38px 38px 0 0;
}

.type-item {
  width: 25%;
  position: relative;
  border-radius: 10px;
  background: #454654;
  padding: 10px 0;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid;
}
.active-bor {
  background: #3979e3;
  color: #ffffff;
  border: 1px solid #3979e3 !important;
}
.custom-badge {
  position: absolute;
  top: -2px;
  left: -1px;
  // font-size: 9px;
  // color: #ffffff;
  background: url(../../assets/img/otgame/recharge_4.png) no-repeat;
  width: 38px;
  height: 33px;
  background-size: 100% 100%;
  // border-radius: 15px 15px 15px 0;
  // padding: 2px 3px;
  // min-width: 28px;
  // text-align: center;
}
.tool-tips-tail {
  position: absolute;
  top: 13px;
  left: 0;
  width: 0;
  height: 0;
  border-left: 0px solid transparent; /* 左边框透明 */
  border-right: 5px solid transparent; /* 右边框透明 */
  border-top: 6px solid #dd0d42; /* 上边框设置颜色和宽度 */
}
.amount-box-list {
  flex-flow: wrap row;
  // margin-top: 20px;
}
.amount-box-list::after {
  content: '';
  width: 31.5%; /* 与.item宽度一致 */
  height: 0; /* 不占用高度 */
}

.amount-box-list-item {
  position: relative;
  border-radius: 8px;
  width: 31.5%;
  margin-bottom: 10px;
  background: #454654;
  padding: 7px 0;
}
.amount-bonus-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: linear-gradient(to right, #ff5d16, #ff9253);
  color: #ffffff;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 0 8px 0 8px;
  font-weight: bold;
}
.first-recharge-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(90deg, rgba(255, 93, 22, 0.15), rgba(255, 146, 83, 0.08));
  border: 1px solid rgba(255, 93, 22, 0.3);
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 10px;
  &__text {
    color: #ff9253;
    font-size: 13px;
    font-weight: bold;
  }
}
.active {
  color: #ffffff !important;
  background: #007dfe;
}
::v-deep .van-checkbox__icon .van-icon {
  border: none !important;
}
/* 确保遮罩层覆盖整个屏幕 */
.full-screen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* 半透明背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

::v-deep .van-loading {
  background-color: transparent !important;
  background: transparent !important;
}
.active-type {
  border-right: 1px solid #fa9614;
  border-top: 1px solid #fa9614;
  border-left: 1px solid #fa9614;
  background: #263144 !important;
  border-radius: 10px 10px 0 0 !important;
  height: 70px !important;
  margin-bottom: -11px;
}
.active-type2 {
  color: #ffffff !important;
  background: #3979e3 !important;
  border: 1px solid #3979e3 !important;
}
.active-type3 {
  border-radius: 0 10px 10px 10px !important;
}
</style>
